import _ from "underscore";

import { Breakdown } from "./breakdown";

import type { BreakdownConfig, BreakdownNode } from "./index";

function getElementId<T>(element: T, config: BreakdownConfig<T, any>) {
  return element?.[config?.id] as string | number;
}

function getElementParentId<T>(element: T, config: BreakdownConfig<T, any>) {
  if (typeof config?.parentId === "function") {
    return config.parentId(element);
  } else {
    return element?.[config?.parentId] as string | number;
  }
}

function getElementChildIds<T>(element: T, config: BreakdownConfig<T, any>) {
  if (typeof config?.childIds === "function") {
    return config.childIds(element);
  } else {
    return element?.[config?.childIds] as string[] | number[];
  }
}

function getNodeWithChildren<T, R = T>(elements: T[] | {
  [id: string | number]: T
}, element: T, breakdown: Breakdown<T, R>, level: number, config: BreakdownConfig<T, R>) {
  let node: BreakdownNode<R>;
  if (config?.transform) {
    node = {
      id: getElementId(element, config),
      ...config.transform(element),
      level,
      // @ts-ignore
      parent: breakdown.all[getElementParentId(element, config)] || null,
      children: null
    };
  } else {
    // @ts-ignore
    node = {
      ...element,
      id: getElementId(element, config),
      level,
      // @ts-ignore
      parent: breakdown.all[getElementParentId(element, config)] || null,
      children: null
    };
  }

  if (level === 1) {
    // @ts-ignore
    breakdown.breakdown[getElementId(element, config)] = node;
  }
  // @ts-ignore
  breakdown.all[getElementId(element, config)] = node;
  let childIds = getElementChildIds(element, config);
  if (!childIds) {
    // @ts-ignore
    childIds = _.chain(elements)
      // @ts-ignore
      .where({ [config.parentId]: getElementId(element, config) })
      .pluck(config.id)
      .value();
  }
  // @ts-ignore
  node.children = _.chain<string | number>(childIds)
    .clone() // Since the list we get from the redux store is immutable
    .sort()
    .map(childId => {
      if (Array.isArray(elements)) {
        return getNodeWithChildren(elements, _.findWhere(elements, { [config.id]: childId }), breakdown, level + 1, config);
      } else {
        return getNodeWithChildren(elements, elements[childId], breakdown, level + 1, config);
      }
    })
    .value();

  return node;
}


export function buildBreakdownFromList<T, R = T>(elements: T[] | { [id: string | number]: T }, config: BreakdownConfig<T, R>) {
  return _(elements)
    .chain()
    .filter(element => getElementParentId(element, config) == null)
    .reduce<Breakdown<T, R>>((breakdownSoFar: Breakdown<T, R>, element: T) => {
      getNodeWithChildren(elements, element, breakdownSoFar, 1, config);
      return breakdownSoFar;
    }, new Breakdown<T, R>(config))
    .value();
}

export default buildBreakdownFromList;
